<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate="Settings.Storage">
          <span *ngIf="premiumRequired" class="mt-0 ms-2 mb-2 border-radius-profile badge information bold" [ngClass]="{'bg-danger': !storageAvailable, 'bg-success': storageAvailable}" translate="Settings.Premium"></span> 
          <app-info-button class="mt-0 ms-2 mb-2" *ngIf="premiumRequired && !storageAvailable" labelName="Settings.OrganisationStorageSection.PrivateStorageTooltip"></app-info-button>
        </h3>    
    </div>
</div>

<div class="p-4 pt-0">
    <div class="alert alert-info border-info p-2" role="alert">
        <span class="lh-base" [innerHTML]="'Settings.OrganisationStorageSection.Information' | translate"></span>
    </div>

    <span class="pt-5 col-12" translate=Settings.OrganisationStorageSection.PrivateStorage></span>
    <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
        <div class="col-9 d-table form-check form-switch">
            <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="privateStorage" name="privateStorage" (change)="toggleUsePrivateStorage($event)" [checked]="blobstorageConnectionstringActive && (!premiumRequired || storageAvailable)" [disabled]="premiumRequired && !storageAvailable">
            <label class="form-check-label pt-1 col-10" for="privateStorage" translate="Settings.OrganisationStorageSection.EnablePrivateStorage"></label>
        </div>
        
        <div *ngIf="blobstorageConnectionstringActive && (!premiumRequired || storageAvailable)" class="col-3 pe-2 text-end">
            <div class="btn-group">
                <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
                </button>
                <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="editBlobStorage()"></a></li>
                </ul>
            </div>
        </div>
    </div>
</div>